import { Box, Tab, Tabs } from '@mui/material';
import { editor as MonacoEditor } from 'monaco-editor';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfigureHardwareTab from './ConfigureHardwareTab';
import DriveModeConfigurationTab from './DriveModeConfigurationTab';
import type { ICardComponent } from '../Devices/DeviceCardBuilder';

type ConfigureSubTab = 'configure-hardware' | 'run-setup';

interface ConfigurePanelTabProps {
  editor: MonacoEditor.IStandaloneCodeEditor | null;
  hardwareDynamicCards: ICardComponent[];
  hardwareIsLoading: boolean;
  driveUnitPortRegistryRev: number;
}

const ConfigurePanelTab: React.FC<ConfigurePanelTabProps> = ({ editor, hardwareDynamicCards, hardwareIsLoading, driveUnitPortRegistryRev }) => {
  const { t } = useTranslation();
  const [selectedSubTab, setSelectedSubTab] = useState<ConfigureSubTab>('configure-hardware');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Tabs
        value={selectedSubTab}
        onChange={(_, value: ConfigureSubTab) => setSelectedSubTab(value)}
        sx={(theme) => ({
          borderBottom: 1,
          borderColor: 'divider',
          minHeight: 40,
          '& .MuiTabs-flexContainer': { gap: 0, justifyContent: 'center' },
          '& .MuiTab-root': { minHeight: 40, textTransform: 'none', fontSize: '0.875rem' },
          '& .MuiTabs-indicator': { backgroundColor: theme.vars?.palette?.accent?.main },
        })}
      >
        <Tab
          value="configure-hardware"
          label={t('editorDrawer.tabs.configureHardware', 'Configure Hardware')}
          aria-label={t('editorDrawer.tabs.configureHardware', 'Configure Hardware')}
        />
        <Tab value="run-setup" label={t('editorDrawer.tabs.robotMode', 'Robot Mode')} aria-label={t('editorDrawer.tabs.robotMode', 'Robot Mode')} />
      </Tabs>
      <Box sx={{ flexGrow: 1, overflowY: 'auto', minHeight: 0 }}>
        {selectedSubTab === 'configure-hardware' && (
          <ConfigureHardwareTab
            dynamicCards={hardwareDynamicCards}
            isLoading={hardwareIsLoading}
            editor={editor}
            driveUnitPortRegistryRev={driveUnitPortRegistryRev}
          />
        )}
        {selectedSubTab === 'run-setup' && <DriveModeConfigurationTab editor={editor ?? undefined} />}
      </Box>
    </Box>
  );
};

export default ConfigurePanelTab;
